export default function IndividualRoundIcon({
    style
}) {
    return <svg style={style} width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 12.0669C12.5714 14.4262 19 11.8026 19 9.80961V6" stroke="#676767" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 9C14.9706 9 19 7.20914 19 5C19 2.79086 14.9706 1 10 1C5.02944 1 1 2.79086 1 5C1 7.20914 5.02944 9 10 9Z" stroke="#676767" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
}